import React, { useState } from 'react';
import { Loader2, Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { authPost } from '../../lib/adminAuth';

export const UnlockPanel = ({ onUnlocked, onSessionExpired }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await authPost('unlock', { password });
      setPassword('');
      onUnlocked();
    } catch (err) {
      if (err.status === 401 && err.message !== 'Incorrect unlock password') onSessionExpired();
      else setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="unlock-form">
      <Input type="password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)}
        placeholder="Unlock password" className="border-[#E8E4DC] bg-white" data-testid="unlock-password-input" />
      {error && <p className="text-sm text-[#C0392B]" data-testid="unlock-error">{error}</p>}
      <Button type="submit" disabled={!password || busy} className="w-full bg-[#3A3530] text-white hover:bg-[#2A2520]" data-testid="unlock-submit-btn">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Lock className="mr-2 h-4 w-4" />}Unlock
      </Button>
    </form>
  );
};

export const LockedScreen = (props) => (
  <div className="flex min-h-[80vh] items-center justify-center px-4" data-testid="locked-screen">
    <div className="w-full max-w-sm rounded-2xl border border-[#E8E4DC] bg-white p-8 shadow-sm">
      <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#F5F1E8]"><Lock className="h-5 w-5 text-[#6B6560]" /></span>
      <h1 className="font-heading text-2xl font-semibold text-[#3A3530]">This section is locked</h1>
      <p className="mb-5 mt-1 text-sm text-[#6B6560]">Enter the unlock password to view client assessments and the calendar. Payment Plans stays open without it.</p>
      <UnlockPanel {...props} />
    </div>
  </div>
);
